import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove platform badge
const badge = document.getElementById('emergent-badge');
if (badge) badge.remove();
new MutationObserver((mutations, obs) => {
  const el = document.getElementById('emergent-badge');
  if (el) { el.remove(); obs.disconnect(); }
}).observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
